class Field {
    constructor({name, key, type, required = false, editable = true, value = '', originValue = '',
                 validation = undefined, verification = undefined, verificationValue = '', verificationError,
                 postpend = {disabled: true}, validChars = undefined, loading = false, isDataField = true, error = '',
                 trusted = false, prioritized = true, updateRule = undefined, choices = undefined,
                 id = null, custom = false, description = '', hasDescription=false, picklistType=''}) {
        Object.assign(this, {
            name,
            key,
            type,
            required,
            editable,
            value,
            originValue,
            validation,
            verification,
            verificationValue,
            verificationError,
            postpend,
            validChars,
            loading,
            isDataField,
            error,
            trusted,
            prioritized,
            updateRule,
            choices,
            id,
            custom,
            description,
            hasDescription,
            picklistType
        });
    }
}

export default Field;
